import React from "react";
import api from "src/store/features/api";
import { useUserSlice } from "src/store/features/user.slice";
import { timestampFormatter } from "src/utils/helpers/DateAndTimeHelpers";
import { IRecentTransactionData } from "./defaults";
import { formatPrice, formatTransactionType } from "./helpers";
import PortfolioTransactions from "./recentTransactions/PortfolioTransactions";
import PortfolioTransactionsDefault from "./recentTransactions/PortfolioTransactionsDefault";

const RecentTransactions = () => {
  // call api here
  // get recent transaction data - at least last 4 transactions.
  const { data: transactions, isLoading } = api.useGetUserRecentTransactionsQuery();

  const {
    defaultCurrency: { code },
    isUnverified,
  } = useUserSlice();

  function isWrongID(str: string) {
    const regex = /[_-]/;
    return regex.test(str);
  }

  // format data from BE for balance component
  const data = React.useMemo((): IRecentTransactionData[] => {
    if (!transactions || !code) return [];
    return transactions
      .filter((tx) => !isWrongID(tx.id))
      .map((tx) => ({
        type: formatTransactionType(tx.type),
        ctid: tx.id,
        value: formatPrice(tx.value, code ?? "AUD"),
        date: tx.timestamp ? timestampFormatter(tx.timestamp) : "-",
      }))
      .slice(0, 4);
  }, [transactions, code]);

  const SHOW_DEFAULT = isLoading || data.length === 0 || isUnverified;

  return (
    <>
      {isUnverified || SHOW_DEFAULT ? ( // IS UNVERIFIED or BLANK VERIFIED ACCOUNT
        <PortfolioTransactionsDefault isLoading={isLoading} />
      ) : (
        <PortfolioTransactions data={data} />
      )}
    </>
  );
};

export default RecentTransactions;
